export default "__VITE_PUBLIC_ASSET__22cc9d65__"